import React from 'react';
import { Icon, Box, Tooltip } from '@mui/material';
import ActSchedule from '@/types/ActSchedule.type';

type Props = {
  actSchedule: ActSchedule;
};

const ActPlanIcon: React.FC<Props> = ({ actSchedule }) => {
  return (
    <Box height={40} width={45} position="relative" sx={{ display: 'flex' }}>
      <Tooltip title={actSchedule.status.name} placement="right">
        <Icon
          sx={{
            fontSize: 25,
            color: actSchedule.status.color,
            position: 'absolute',
            zIndex: 1050,
            right: 0,
            bottom: 0,
          }}
        >
          {actSchedule.status.icon}
        </Icon>
      </Tooltip>
      <Tooltip title={actSchedule.style.name} placement="right">
        <Icon
          sx={{
            fontSize: 25,
            color: actSchedule.style.color,
            position: 'absolute',
            zIndex: 1000,
          }}
        >
          {actSchedule.style.icon}
        </Icon>
      </Tooltip>
    </Box>
  );
};
export default ActPlanIcon;
